// src/components/registration/steps/userGroupSteps/UserGroupsStep2Configure.jsx

import React from "react";
import PropTypes from "prop-types";
import MultiStyleButton from "../../../../systemUtils/MultiStyleButton";
import UserGroup from "../../supportComponents/UserGroup";
import validate from "../../functions/validation";
import "../UserSystemCard.css"; // Ensure necessary styles are included

const UserGroupsStep2Configure = ({
  setCardStep,
  userGroups,
  setUserGroups,
  addUserGroup,
  removeUserGroup,
  updateUserGroup,
  addRole,
  removeRole,
  updateRole,
  checkDuplicateEmails,
  undo,
  redo,
  canUndo,
  canRedo,
}) => {
  // Handle validation before moving to confirmation
  const handleContinue = () => {
    const { isValid, errors } = validate(userGroups);
    if (!isValid) {
      // For simplicity, alert the first error found
      const firstErrorKey = Object.keys(errors)[0];
      alert(errors[firstErrorKey]);
      return;
    }
    // Check if at least two user groups are created
    if (userGroups.length < 2) {
      alert("Please create at least two user groups before continuing.");
      return;
    }

    setCardStep(3);
  };

  return (
    <>
      {/* Undo/Redo Controls */}
      <div className="undo-redo-container">
        <MultiStyleButton
          label="Undo"
          buttonType="cancel"
          onClick={undo}
          disabled={!canUndo}
        />
        <MultiStyleButton
          label="Redo"
          buttonType="cancel"
          onClick={redo}
          disabled={!canRedo}
        />
      </div>

      {/* User Groups List */}
      <div className="user-groups-container">
        {userGroups.length > 0 ? (
          userGroups.map((group, groupIndex) => (
            <UserGroup
              key={groupIndex}
              group={group}
              groupIndex={groupIndex}
              updateUserGroup={updateUserGroup}
              removeUserGroup={removeUserGroup}
              addRole={addRole}
              removeRole={removeRole}
              updateRole={updateRole}
              checkDuplicateEmails={checkDuplicateEmails}
            />
          ))
        ) : (
          <p className="no-groups-message">No User Groups added yet.</p>
        )}

        {/* Add User Group Button */}
        <div className="add-user-group-container">
          <MultiStyleButton
            label="Add User Group"
            buttonType="approve"
            onClick={addUserGroup}
          />
        </div>
      </div>

      {/* Navigation Buttons */}
      <div className="continue-button-container">
        <p className="card-subtitle">
          Click continue after your configuration is complete
        </p>
        {/* <MultiStyleButton
          label="Back"
          buttonType="cancel"
          onClick={() => setCardStep(1)}
        /> */}
        <MultiStyleButton
          label="Continue"
          buttonType="approve"
          onClick={handleContinue}
        />
      </div>
    </>
  );
};

// Minor fix: rename addRole => addUserGroupRole for clarity if needed
// Or keep as is if you prefer

UserGroupsStep2Configure.propTypes = {
  setCardStep: PropTypes.func.isRequired,
  userGroups: PropTypes.array.isRequired,
  setUserGroups: PropTypes.func.isRequired,
  addUserGroup: PropTypes.func.isRequired,
  removeUserGroup: PropTypes.func.isRequired,
  updateUserGroup: PropTypes.func.isRequired,
  addRole: PropTypes.func.isRequired,
  removeRole: PropTypes.func.isRequired,
  updateRole: PropTypes.func.isRequired,
  checkDuplicateEmails: PropTypes.func.isRequired, // new prop
  undo: PropTypes.func.isRequired,
  redo: PropTypes.func.isRequired,
  canUndo: PropTypes.bool.isRequired,
  canRedo: PropTypes.bool.isRequired,
};

export default UserGroupsStep2Configure;
